import ProvincesMaroc from "assets/ProvincesMaroc/ProvincesMaroc.json";
import HeadSeo from "components/HeadSeo/HeadSeo";
import PrixImmobilier from "containers/v2/PrixImmobilier";
import siteMetadata from "data/siteMetadata";
import nookies from "nookies";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { resetState } from "redux/slices/carteprixReducer";
import api_call_v2 from "utils/API_CALL/api_call_v2";

const empty_localisation_object = {
  _id: "",
  prix_appartement: 0,
  prix_villa: 0,
  province: "",
  region: "",
  province_ar: "",
  indice_confiance_appartement: 0,
  indice_confiance_villa: 0,
  lat: 0,
  lng: 0,
};
const RendringPage = ({ provincesSSR }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetState());
  }, []);

  function addProductJsonLd() {
    return {
      __html: `
      {
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [
          {
          "@type": "ListItem", 
          "position": 1, 
          "name": "Prix Immobilier au Maroc",
          "item": "https://agenz.ma/prix-immobilier-maroc"  
        }
      ]
      }
      
  `,
    };
  }
  return (
    <>
      <HeadSeo
        title={`Prix de l’immobilier au Maroc | AgenZ`}
        description={`Prix immobilier au Maroc : Vous avez un projet immobilier au Maroc ? Consultez le prix du m2 sur la carte des prix agenz. Découvrez aussi ces villas et appartements à vendre, uniquement sur agenz`}
        ogImageUrl={
          "https://storage.googleapis.com/headers-agenz/Logo%20300_%20300%20px.jpg"
        }
        ogTwitterImage={siteMetadata.siteLogoSquare}
        ogType={"article"}
        ogTitle={"Prix de l’immobilier au Maroc | AgenZ"}
        ogDescription={
          "Prix immobilier au Maroc : Vous avez un projet immobilier au Maroc ? Consultez le prix du m2 sur la carte des prix agenz. Découvrez aussi ces villas et appartements à vendre, uniquement sur agenz"
        }
        canonicalUrl={`https://agenz.ma/prix-immobilier-maroc`}
        structuredData={addProductJsonLd()}
      >
        <></>
      </HeadSeo>

      <PrixImmobilier
        provincesSSR={provincesSSR}
        region={""}
        province={""}
        commune={""}
        quartier={""}
        pricesSSR={empty_localisation_object}
        provincesMaroc={provincesSSR}
        communesSSR={[]}
      />
    </>
  );
};

export async function getServerSideProps({ req, res, resolvedUrl, query }) {
  const cookies = nookies.get({ req });
  const accessToken = cookies.AccessToken;
  let user = null;
  if (accessToken) {
    try {
      const res = await api_call_v2(
        undefined,
        "get",
        "getUser",
        {},
        "cloud_functions",
        true
      );
      user = res.data;
    } catch (e) {}
  }

  try {
    return {
      props: {
        provincesSSR: ProvincesMaroc,
        user,
      },
    };
  } catch (e) {
    return {
      props: {
        provincesSSR: ProvincesMaroc,
        user,
      },
    };
  }
}

export default RendringPage;
